import { useEffect } from "react";

import EvalRunResultItem from "./EvalRunResultItem";

export default EvalRunResultItems;

function EvalRunResultItems(props) {
  const { evalRun, selectedResult, setSelectedResult } = props;

  const results = evalRun?.results ?? [];

  // Open the first result so the panels to the right aren't empty on arrival.
  useEffect(() => {
    setSelectedResult(results[0]);
  }, [evalRun]);

  return (
    <div className="col-span-1 border rounded-lg h-full min-h-0 flex-1 flex flex-col overflow-auto">
      {results.map((resultItem, idx) => {
        const isResultItemActive =
          resultItem.model === selectedResult?.model &&
          resultItem.persona === selectedResult?.persona;

        const handleResultItemClick = (e) => {
          e.stopPropagation();
          setSelectedResult(resultItem);
        };

        return (
          <EvalRunResultItem
            key={idx}
            evalRunResultItem={resultItem}
            isActiveResultItem={isResultItemActive}
            onResultItemClick={handleResultItemClick}
          />
        );
      })}
    </div>
  );
}
